import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Axios from "axios";

import { url } from "../../../../config/config";
import { useStyles } from "./BookSidebar.css";

class GenreList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: [],
    };
  }

  componentDidMount() {
    this.getCategoryData();
  }

  getCategoryData = async () => {
    const response = await Axios.get(`${url}/api/categories`);
    if (response.data.length !== 0) {
      this.setState({
        category: response.data,
      });
    }
  };

  handleClick = (categoryId) => {
    this.props.history.push(`/books/category/genre/${categoryId}`);
  };

  render() {
    const { classes } = this.props;
    this.state.category.sort(() => Math.random() - 0.5);
    return (
      <div className={classes.root}>
        <h3>Genre</h3>
        {this.state.category.slice(0, 5).map((category, index) => (
          <div
            key={index}
            className={classes.labelStyle}
            onClick={() => this.handleClick(category.name)}
          >
            <p>{category.name}</p>
          </div>
        ))}
        <Link to="/books/category/genre" className={classes.linkStyle}>
          See More...
        </Link>
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(GenreList));
